import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import EmployeeBonusCreate from "./EmployeeBonusCreate";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import BaseApi from "../../utils/BaseApi";

// icons
import EmailIcon from "@mui/icons-material/Email";


class EmployeeBonusList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bonuses: [],
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveBonuses();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveBonuses();
        }
    }

    async retrieveBonuses() {
        this.setState(
            {
                bonuses: null,
            }
        );
        const url = 'employee_bonus/';
        const api = new BaseApi();
        let params = {
            declined: false,
        }
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                bonuses: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    async email() {
        const url = 'employee_bonus/email/';
        const api = new BaseApi();
        let params = {}
        await api.get(
            url,
            params
        );
    }

    render() {
        if (!this.state.bonuses) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Премии'}
                    url={'financial/bonus'}
                    data={this.state.bonuses}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    callBack={this.retrieveBonuses.bind(this)}
                    extraComponents={[
                        {
                            component: EmployeeBonusCreate,
                            componentProps: {},
                            callBack: this.retrieveBonuses.bind(this)
                        },
                        {
                            component: CommonCallBackButton,
                            componentProps: {
                                label: 'Письмо',
                                icon: EmailIcon,
                                color: 'primary',

                            },
                            callBack: this.email.bind(this),
                        },

                    ]}
                    fields={[
                        {
                            title: 'ФИО',
                            name: ['employee.last_name', 'employee.first_name', 'employee.patronymic'],
                            visible: true,
                        },
                        {
                            title: 'Комментарий премии',
                            name: 'description',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['description', ],
                                baseUrl: 'employee_bonus',
                            },
                        },
                        {
                            title: 'Сумма',
                            name: 'salary',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['salary', ],
                                baseUrl: 'employee_bonus',
                            },
                        },
                        {
                            title: 'Дата выплаты',
                            name: 'pay_date',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['pay_date', ],
                                baseUrl: 'employee_bonus',
                            },
                        },
                        {
                            title: 'Согласовано',
                            name: 'approved',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['approved', ],
                                baseUrl: 'employee_bonus',
                            },
                        },
                        {
                            title: 'Выплачено',
                            name: 'payed',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['payed', ],
                                baseUrl: 'employee_bonus',
                            },
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(EmployeeBonusList)